// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"a48e819d","453":"ae6cc063"}[chunkId] + ".chunk.js";
};